const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: -0.5,
  y: 0.5,
  width: 7,
  height: 9,
  transform: "matrix(1 0 0 -1 4 13)",
  stroke: "#0081CC"
});

var _ref3 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: -0.5,
  y: 0.5,
  width: 7,
  height: 9,
  transform: "matrix(1 0 0 -1 4 29)",
  stroke: "#0081CC"
});

var _ref4 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: -0.5,
  y: 0.5,
  width: 7,
  height: 9,
  transform: "matrix(1 0 0 -1 24 13)",
  stroke: "#0081CC"
});

var _ref5 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M22.4004 24.8256C22.4004 24.6272 22.4612 24.4544 22.5828 24.3072C22.7108 24.16 22.8708 24.0608 23.0628 24.0096C23.0884 24.0032 23.13 24 23.1876 24C23.5204 24 23.7636 24.1312 23.9172 24.3936C24.0004 24.5216 24.042 24.6656 24.042 24.8256C24.042 25.0048 23.9876 25.168 23.8788 25.3152C23.7764 25.456 23.6356 25.5552 23.4564 25.6128C23.3988 25.6256 23.322 25.632 23.226 25.632C23.0212 25.632 22.8452 25.5712 22.698 25.4496C22.4996 25.296 22.4004 25.088 22.4004 24.8256Z",
  fill: "#1E3F6B"
});

var _ref6 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25.466 24.8256C25.466 24.6272 25.5268 24.4544 25.6484 24.3072C25.7764 24.16 25.9364 24.0608 26.1284 24.0096C26.154 24.0032 26.1956 24 26.2532 24C26.586 24 26.8292 24.1312 26.9828 24.3936C27.066 24.5216 27.1076 24.6656 27.1076 24.8256C27.1076 25.0048 27.0532 25.168 26.9444 25.3152C26.842 25.456 26.7012 25.5552 26.522 25.6128C26.4644 25.6256 26.3876 25.632 26.2916 25.632C26.0868 25.632 25.9108 25.5712 25.7636 25.4496C25.5652 25.296 25.466 25.088 25.466 24.8256Z",
  fill: "#1E3F6B"
});

var _ref7 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28.5316 24.8256C28.5316 24.6272 28.5924 24.4544 28.714 24.3072C28.842 24.16 29.002 24.0608 29.194 24.0096C29.2196 24.0032 29.2612 24 29.3188 24C29.6516 24 29.8948 24.1312 30.0484 24.3936C30.1316 24.5216 30.1732 24.6656 30.1732 24.8256C30.1732 25.0048 30.1188 25.168 30.01 25.3152C29.9076 25.456 29.7668 25.5552 29.5876 25.6128C29.53 25.6256 29.4532 25.632 29.3572 25.632C29.1524 25.632 28.9764 25.5712 28.8292 25.4496C28.6308 25.296 28.5316 25.088 28.5316 24.8256Z",
  fill: "#1E3F6B"
});

var _ref8 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18 22V10H17V22H18Z",
  fill: "#1E3F6B",
  stroke: "#1E3F6B",
  strokeWidth: 0.5
});

const SvgEquationMatrix3 = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("title", null, title), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEquationMatrix3, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/equation-matrix-3.0f1aecd3.svg";
export { ForwardRef as ReactComponent };